import Dialog from '../../../../organisms/Dialog';
import { SnapshotRepublicationPayload } from '../../../../../services/eventingApi';
import { buttonClass } from '../shared/ui';

interface BackfillConfirmDialogProps {
  request: SnapshotRepublicationPayload | null;
  submitting: boolean;
  onClose: () => void;
  onConfirm: (request: SnapshotRepublicationPayload) => void;
}

const BackfillConfirmDialog = ({ request, submitting, onClose, onConfirm }: BackfillConfirmDialogProps) => (
  <Dialog
    id="event-platform-backfill"
    show={Boolean(request)}
    onClose={onClose}
    header="Pedir snapshots ao serviço dono"
    body={
      <p className="text-sm dark:text-gray-200">
        O serviço <code>{request?.sourceService}</code> vai republicar o snapshot de {request?.aggregateIds.length} agregado(s){' '}
        <code>{request?.aggregateType}</code>, só para o consumidor <code>{request?.target}</code>.
      </p>
    }
    footer={
      <div className="flex justify-end gap-2">
        <button type="button" className={buttonClass.cancel} onClick={onClose}>
          Cancelar
        </button>
        <button type="button" className={buttonClass.secondary} disabled={submitting} onClick={() => request && onConfirm(request)}>
          {submitting ? 'Pedindo…' : 'Pedir snapshots'}
        </button>
      </div>
    }
  />
);

export default BackfillConfirmDialog;
